import React, { useState } from 'react'
import LoginLayout from 'Pages/Layout/LoginLayout'
import { RootState } from 'Store'
import { connect, useDispatch } from 'react-redux'
import { Input, FormItem } from 'Components/form'
import { ResetPasswordReq } from 'Store/user/types'
import { resetPasswordAPI } from 'Store/user/api'
import { selectEvent } from 'Store/user/selector'
import { clearEventAction } from 'Store/user/actions'
import EventModal from 'Components/modal/EventModal'
import { Row } from 'antd'
import styled from 'styled-components'
import { MyTheme } from 'Components/common/Theme'
import { validateEmail } from 'helpers/format'
import { useNavigate } from 'react-router-dom'

type Props = {} & ReduxProps

const VerifyPassword: React.FunctionComponent<Props> = props => {
  const [email, setEmail] = useState<string>('')
  const [emailError, setEmailError] = useState(false)
  const { event } = props
  const history = useNavigate()

  const dispatch = useDispatch()

  const onResetPassword = (): void => {
    const req: ResetPasswordReq = {
      email: email,
    }
    dispatch(resetPasswordAPI(req))
  }

  const onValidate = (): void => {
    if (!email.trim()) {
      setEmailError(true)
      return
    }

    if (!validateEmail(email)) {
      setEmailError(true)
      return
    }

    onResetPassword()
  }

  const onChangeEmail = (val: string): void => {
    setEmail(val)
    if (val && emailError && validateEmail(email)) {
      setEmailError(false)
    }
  }

  const errorStatus = (isError: boolean): string => {
    return isError ? 'error' : ''
  }

  const clearEvent = (): void => {
    dispatch(clearEventAction())
  }

  const onSuccess = (): void => {
    clearEvent()
    history('/')
  }

  return (
    <>
      <EventModal
        key="reset-password"
        event={[event]}
        enable={true}
        successCalback={onSuccess}
        errorCalback={clearEvent}
      />
      <LoginLayout title={'รีเซ็ตรหัสผ่าน'} onSubmit={onValidate} btnText="ยืนยัน" isLoginMode={false}>
        <FormItem label="" status={errorStatus(emailError)} error="กรุณาระบุอีเมลให้ถูกต้อง">
          <Input placeholder="อีเมล" name="email" value={email} onChange={onChangeEmail} />
        </FormItem>
        <Row>
          <Text>*ระบุอีเมลที่ต้องการรับลิ้งค์ในการเปลี่ยนรหัสผ่านของคุณ</Text>
        </Row>
      </LoginLayout>
    </>
  )
}

const Text = styled.p`
  color: ${(props: { theme: MyTheme }): string => props.theme.colors.grey};
  font-family: ${(props: { theme: MyTheme }): string => props.theme.fontFamily.regular};
  font-size: ${(props: { theme: MyTheme }): string => props.theme.typography.body4};
`

const mapStateToProps = (state: RootState): any => {
  return {
    event: selectEvent(state),
  }
}

type ReduxProps = ReturnType<typeof mapStateToProps>

export default connect(mapStateToProps)(VerifyPassword)
